import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as api from '../../api/app/emailReportAssetApi';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { EmailReportAssetInputs } from '../../types/app/emailReportAsset.types';
import { dictionary } from '../../utils/core/dictionary';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/emailReportAsset.functions';
import { paths } from '../../utils/core/routes';
import { EmailReportAssetForm } from './EmailReportAssetForm';
import { useStyles } from './EmailReportAssetForm.styles';

export function EmailReportAssetCreate() {
  const classes = useStyles();
  const { parentId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { mutate: mutateCreateEmailReport } = useMutation(api.createEmailReportAsset);

  const handleOnSubmit: SubmitHandler<EmailReportAssetInputs> = (data: EmailReportAssetInputs) => {
    const requestData = convertDataFromInputToCreateRequest({
      ...data,
      emailReportId: Number(parentId),
    });

    mutateCreateEmailReport(
      { ...requestData },
      {
        onSuccess: () => {
          enqueueSnackbar(dictionary.EMAIL_REPORT_CREATED, { variant: 'success' });
          navigate(`${paths.EMAIL_REPORT_DETAIL}/${Number(parentId)}`);
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <PageHeader title={dictionary.EMAIL_REPORT_CREATE} />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <EmailReportAssetForm
                onSubmit={handleOnSubmit}
                onBack={() => navigate(`${paths.EMAIL_REPORT_DETAIL}/${Number(parentId)}`)}
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
